import {
  Dialog,
  Stack,
  SwipeableDrawer,
  Typography,
  useTheme,
} from "@mui/material";
import { Task } from "../../../services/swagger";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import FieldLabel from "../../atoms/FieldLabel";
import useBreakpoint from "../../../hooks/useBreakpoint";
import FormTemplate from "../../templates/FormTemplate";

interface TaskProductSerialListProps {
  task: Task;
  open: boolean;
  onClose: () => any;
}

interface TaskProductSerialListContentProps {
  task: Task;
}

function TaskProductSerialListContent(
  props: TaskProductSerialListContentProps
) {
  const { t } = useTranslation("Product");
  const { task } = props;
  const breakpoint = useBreakpoint();
  const productsWithSerials = useMemo(() => {
    return task.products.filter((product) => product.serialList.length > 0);
  }, [task]);

  return (
    <Stack spacing={2}>
      {productsWithSerials.length === 0 && (
        <Typography
          align={breakpoint.md ? undefined : "center"}
          color="text.secondary"
        >
          {t("NoSerialsAdded")}
        </Typography>
      )}
      {productsWithSerials.map((product) => (
        <Stack
          key={product.itemCode}
          alignItems={breakpoint.md ? undefined : "center"}
          mb={2}
        >
          <FieldLabel>
            {product.itemCode} - {product.name}
          </FieldLabel>
          {product.serialList.map((serial) => (
            <Typography key={serial}>{serial}</Typography>
          ))}
        </Stack>
      ))}
    </Stack>
  );
}

export default function TaskProductSerialList(
  props: TaskProductSerialListProps
) {
  const { t } = useTranslation("Product");
  const { task } = props;
  const theme = useTheme();
  const breakpoint = useBreakpoint();

  if (breakpoint.md) {
    return (
      <Dialog open={props.open} onClose={props.onClose}>
        <FormTemplate
          title={t("Serials")}
          onCancel={props.onClose}
          disableFooter
        >
          <TaskProductSerialListContent task={task} />
        </FormTemplate>
      </Dialog>
    );
  } else {
    return (
      <SwipeableDrawer
        anchor="bottom"
        open={props.open}
        onClose={props.onClose}
        onOpen={() => {}}
        sx={{ zIndex: 1300 }}
        PaperProps={{
          sx: {
            maxHeight: "70%",
            minHeight: 300,
            borderTopRightRadius: 2 * (theme.shape.borderRadius as number),
            borderTopLeftRadius: 2 * (theme.shape.borderRadius as number),
            p: 4,
            px: 2,
          },
        }}
      >
        <TaskProductSerialListContent task={task} />
      </SwipeableDrawer>
    );
  }
}
